export const USER_BASE_API_URL = process.env.REACT_APP_USER_BASE_API_URL;

// GET - Retorna os hospitais
export const USER_GET_HOSPITALS_ENDPOINT = '/users/permissions/hospitals/paged/logged';
